module.exports = __webpack_public_path__ + "static/media/свободные веса - Лавка для нижнеи части спины.0bb6e3a6.jpg";